jQuery_T4NT(document).ready(function($) {

     /**
     * Variant selection changed
     */
	  $( document ).on( "variant:change", function( evt, variant ) {
	    //console.log( variant );
	  });
     
      console.log( 'looplabz' );
     // tag-filters_lplbz
    //   setTimeout(function(){
    //      $( ".tag-filters_lplbz" ).appendTo( "#shopify-section-nt_filter2 .wrap_filter" );
    //       $('.tag-filters_lplbz').show();
    //   }, 1000)
    // $(document).bind("ajaxComplete", function(){
    //   setTimeout(function(){
    //      $( ".tag-filters_lplbz" ).appendTo( "#shopify-section-nt_filter2 .wrap_filter" );
    //       $('.tag-filters_lplbz').show();
    //   }, 1000)
    // })

  $(document).bind("ajaxComplete", function(){
    setTimeout(function(){
          queryParas = window.location.href.slice(window.location.href.indexOf('?') + 1);
          url = queryParas;
          if (window.location.href.indexOf("?") > -1) {
            
            $( ".loopTags a, ._clr_activeFlr a" ).each(function( index ) {
              href = $( this ).attr('href');
              $( this ).attr('href',href+'?'+queryParas );
            });
          }
       }, 1000)
    
    })
    queryParas = window.location.href.slice(window.location.href.indexOf('?') + 1);
    url = queryParas;
    if (window.location.href.indexOf("?") > -1) {
      
      $( ".loopTags a, ._clr_activeFlr a" ).each(function( index ) {
        href = $( this ).attr('href');
        $( this ).attr('href',href+'?'+queryParas );
      });
    }
    
   $('.nt_currency.pr.cg.currencies.sp_currencies').appendTo('._hdrClmLst');
  
});
      